import React, { Component } from "react";
import { Container, Button } from "react-bootstrap";
import MenuLeftCMS from "./ct-fragmentsidemenu";
import { GetText } from "../config/helper";
import "../config/global";
import CTNA from "./ct-fragmentna";
import Error404 from "../Error404";
import DateTimeFormats from "../config/date-time-format";
import { ReplaceText } from '../config/helper';

const authKey = global.config.kindcode.training[18] + global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[17] + global.config.authBearerKey;

export default class CTSuccessDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink: "none",
      paramlink: "",
      stTitle: "",
      stories_docid: "",
      stories_createby: '',
      stories_createdate: '',
      stories_name: "",
      stories_email: "",
      stories_position: "",
      stories_company: "",
      stories_type: "",
      stories_message: "",
      stories_status: "",
      stories_language: "",
      stories_number: "",
    };
    this.loadDetailData = this.loadDetailData.bind(this);
  }
  handleBack = (currpage) => {
    var backurl = global.config.urlCms+"/"+currpage;
    if(this.state.paramlink === "viewin") { 
      backurl += "/incoming";
    } else {
      if(this.state.stories_language !== "" && this.state.stories_language !== "Indonesian") { backurl += "/"+this.state.stories_language; }
      else { backurl += "/indonesia"; }
    }
    window.location.href = backurl;
  };

  loadDetailData(currpage, typelink, docid) {
    if (docid !== "") {
      document.getElementById("loading-area").style.display = "block";
      var subtitle="", urlfetch="", authKeyLP=""; 
      if(typelink === "viewin") { 
        subtitle = " Incoming"; 
        urlfetch = global.config.urlLink + "/storiesinview/" + docid;
        authKeyLP = authKey2;
      } else {
        subtitle = ""; 
        urlfetch = global.config.urlLink + "/storiesview/" + docid;
        authKeyLP = authKey;
      }
              

      fetch(urlfetch, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: authKeyLP,
        },
      }).then((res) => {
          if (res.status === 200) return res.json();
      }).then((resJson) => {
          document.getElementById("loading-area").style.display = "none";
          if (resJson.status === "200") {
            if (resJson.values[0].content[0].maincontent !== undefined) {
              var resultContent = resJson.values[0].content[0].maincontent;
              var lName = "", lEmail = "", lPosition = "", lMessage = "", lCompany = "", lType="", lStatus = "", lLanguage="", lNumber = "", cDate = "";

              if (resultContent.storiesName !== undefined) { lName = resultContent.storiesName; }
              if (resultContent.storiesEmail !== undefined) { lEmail = resultContent.storiesEmail; }
              if (resultContent.storiesPosition !== undefined) { lPosition = resultContent.storiesPosition; }
              if (resultContent.storiesCompany !== undefined) { lCompany = resultContent.storiesCompany; }
              if (resultContent.storiesType !== undefined) { lType = resultContent.storiesType; }
              if (resultContent.storiesLanguage !== undefined) { lLanguage = resultContent.storiesLanguage; }
              if (resultContent.storiesSortNumber !== undefined) { lNumber = resultContent.storiesSortNumber; }
              if (resultContent.storiesMessage !== undefined) {
                lMessage = ReplaceText(resultContent.storiesMessage);
              }
              if (resJson.values[0].content[0].createdate !== undefined) {
                cDate = DateTimeFormats(resJson.values[0].content[0].createdate._seconds,"datetime-short");
              }
              this.setState({
                activelink: currpage,
                paramlink: typelink,
                stTitle: GetText()? `Detail${subtitle} Kisah Sukses` : `Detail${subtitle} Success Story`,
                stories_docid: resJson.values[0].docid,
                stories_createby: resultContent.createByName,
                stories_createdate: cDate,
                stories_name: lName,
                stories_email: lEmail,
                stories_position: lPosition,
                stories_company: lCompany,
                stories_type: lType,
                stories_message: lMessage,
                stories_status: resultContent.status,
                stories_language: lLanguage,
                stories_number: lNumber
              });
            } else {
              console.log("Something wrong happened");
            }

          } else {
            window.location.href = global.config.urlCms + "/" + currpage + "/add";
          }
        })
        .catch((err) => err);
    } else {
      window.location.href = global.config.urlCms + "/" + currpage + "/add";
    }
  }
  componentDidMount() {
    var urlpath = window.location.pathname;
    if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
      urlpath = urlpath.substring(0,urlpath.length-1);
    }
    var arrUrl = urlpath.split("/");
    
    var tabKey="", tabKey2="", docId="";
    if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
      tabKey = arrUrl[arrUrl.length-2];
      tabKey2 = arrUrl[arrUrl.length-1];
    } else if(arrUrl.length===5 && arrUrl[arrUrl.length-1] !== "") {
        tabKey = arrUrl[arrUrl.length-3];
        tabKey2 = arrUrl[arrUrl.length-2];
        docId = arrUrl[arrUrl.length-1];
    }
    if(tabKey === "") {
      this.setState({
          activelink: "pnf",
          stTitle : (tabKey2 === "view")? "Detail Success Stories" : (tabKey2 === "viewin")? "Detail Incoming Success Stories" : "",
          paramlink: tabKey2,
        });
    } else {
      this.loadDetailData(tabKey,tabKey2,docId);
    }
    
  }
  
  render() {
    return (
      <div className="setting">
        <Container>
          {this.state.activelink === "pnf" ? (
            <Error404 />
          ) : localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2] ? 
          (<>
              <div className="row py-5 mb-5">
              {/* === start - body */}
                <div className="col-md-3 bg-light">
                  { 
                    (this.state.activelink !== "none") && 
                      <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                  
                  }
                </div>
                <div className="col-md-9 p-4">
                  <div className="row">
                    <div>
                      <h3 className="mb-4">{GetText() ? "Kisah Sukses" : "Success Story"}</h3>
                    </div>
                    <div className="mt-3">
                      <div className="row show">
                          <div className="col-6">
                            <h5>{this.state.stTitle} {this.state.stories_number !== "" && `#${this.state.stories_number}`}</h5>
                          </div>
                          <div className="col-6 d-flex justify-content-end">
                             <Button variant="secondary" size="sm" onClick={this.handleBack.bind(this, this.state.activelink)}>&#9664; back</Button>
                          </div>
                      </div>
                      <div className="row">
                        <span className="text-muted">
                          created by {this.state.stories_createby} <span className="ms-4">on {this.state.stories_createdate}</span><br/>
                          status : {this.state.stories_status === 1? "Active": "Inactive"}
                          {this.state.paramlink !== "viewin" && 
                            <>, <span className="ms-4">{this.state.stories_language} version</span> </>
                          }
                        </span>
                      </div>
                      <div className="row mt-4">
                          <div className="col-3">Name</div>
                          <div className="col-9">{this.state.stories_name}</div>
                      </div>
                      <div className="row mt-3">
                          <div className="col-3">Email</div>
                          <div className="col-9">{this.state.stories_email}</div>
                      </div>
                      <div className="row mt-3">
                          <div className="col-3">Position</div>
                          <div className="col-9">{this.state.stories_position}</div>
                      </div>
                      <div className="row mt-3">
                          <div className="col-3">Company</div>
                          <div className="col-9">{this.state.stories_company}</div>
                      </div>
                      <div className="row mt-3">
                          <div className="col-3">Type</div>
                          <div className="col-9">{this.state.stories_type}</div>
                      </div>
                      <div className="row mt-3">
                          <div className="fw-bold" >Message</div>
                          <div>{this.state.stories_message}</div>
                      </div>
                     
                    </div>
                  </div>
                </div>
              {/* === end - body */}
              </div>
            </>
          ) : (
            <div>
              <CTNA />
            </div>
          )}
          <div id="loading-area" className="d-none loading"></div>
        </Container>
      </div>
    );
  }
}
